module.exports = __webpack_public_path__ + "assets/img/19.81cb599b.png";